import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Footer = () => {
  return (
    <footer className="py-4 mt-auto" style={{ backgroundColor: '#0a4a7d', color: 'white' }}>
      <Container>
        <Row>
          <Col md={4}>
            <h5 style={{ fontFamily: 'Montserrat, sans-serif' }}>Contact Us</h5>
            <p style={{ fontFamily: 'Roboto, sans-serif' }}>Address: Door No. #83-9-1462/1, Green Land Nagar, R Agraharam, Guntur</p>
            <p style={{ fontFamily: 'Roboto, sans-serif' }}>Phone: 8333056229, 9182842357</p>
            <p style={{ fontFamily: 'Roboto, sans-serif' }}>Email: ormtrust@rediffmail.com</p>
          </Col>
          <Col md={4}>
            <h5 style={{ fontFamily: 'Montserrat, sans-serif' }}>Working Regions</h5>
            <ul style={{ fontFamily: 'Roboto, sans-serif', listStyle: 'none', paddingLeft: '0' }}>
              <li>North India</li>
              <li>East India</li>
              <li>West India</li>
              <li>South India</li>
            </ul>
          </Col>
          <Col md={4}>
            <h5 style={{ fontFamily: 'Montserrat, sans-serif' }}>Legal</h5>
            <p style={{ fontFamily: 'Roboto, sans-serif' }}>Darpan ID: AP/2023/0350310</p>
            <p style={{ fontFamily: 'Roboto, sans-serif' }}>Regd. No.: 66/2022</p>
          </Col>
        </Row>
        <Row className="text-center mt-3">
          <Col>
            <p style={{ fontFamily: 'Roboto, sans-serif' }}>&copy; {new Date().getFullYear()} ORM Trust. All Rights Reserved.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;